module.exports = __webpack_public_path__ + "static/media/temperature.83f22d10.svg";